import React from "react"
import PropTypes from "prop-types"
import KeyValueShape from "../../state/shapes/KeyValueShape"
import Widget from "../layout/widget/Widget"
import GaugeComparisonChart from "../charts/generic/GaugeComparisonChart"

function TotalEmployees({ exportEndpoint, appliedFilters, data }) {
  const titleKey="Widgets.TotalEmployees.Title"
  return (
    <Widget
      columns={1}
      titleKey={titleKey}
      exportEndpoint={exportEndpoint}
      appliedFilters={appliedFilters}
    >
      <GaugeComparisonChart data={data} titleKey={titleKey}/>
    </Widget>
  )
}

TotalEmployees.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape(KeyValueShape)).isRequired,
  exportEndpoint: PropTypes.string.isRequired,
}

export default TotalEmployees



// WEBPACK FOOTER //
// ./src/components/widgets/TotalEmployees.jsx